<ng-container *ngIf="draggableToMap; else dropListTmpl">
  <mat-accordion>
    <sn-camera-list-item
      class="draggable-item"
      *ngFor="let camera of cameras; trackBy: trackCamera"
      [camera]="camera"
      [showLocation]="showLocation"
      [actions]="actions"
      [draggableToMap]="true"
      (click)="toggleCamera(camera)"
    >
      <div class="wrapper" *ngIf="canChange">
        <sn-icon
          cdkDrag
          cdkDragHandle
          matTooltip="Drag and drop to change camera position"
          matTooltipPosition="below"
          class="cameraHandle"
          (click)="$event.stopPropagation()"
          (cdkDragReleased)="onDragRelease($event, camera)"
          (cdkDragStarted)="onDragStart($event)"
        >
          location_on
        </sn-icon>
      </div>
    </sn-camera-list-item>
  </mat-accordion>
</ng-container>

<ng-template #dropListTmpl>
  <mat-accordion
    cdkDropList
    [cdkDropListOrientation]="'vertical'"
    [cdkDropListDisabled]="!draggableList"
    (cdkDropListDropped)="onDropped($event)"
  >
    <sn-camera-list-item
      cdkDrag
      class="cdk-drag-element"
      *ngFor="let camera of cameras; trackBy: trackCamera"
      [cdkDragLockAxis]="'y'"
      [camera]="camera"
      [showLocation]="showLocation"
      [actions]="actions"
      (cdkDragReleased)="onDragRelease($event)"
      (click)="toggleCamera(camera)"
    >
      <sn-icon
        cdkDragHandle
        id="listDragHandle"
        class="mat-list-icon"
        (touchmove)="$event.preventDefault()"
      >
        drag_indicator
      </sn-icon>
    </sn-camera-list-item>
  </mat-accordion>
</ng-template>
